import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

/**
 * `<nb-switch>` — an on/off toggle (Mockup `.switch`).
 *
 * Renders a real `role="switch"` button: Space/Enter toggle, `aria-checked`
 * reflects state, and an invisible expanded hit area meets the 44pt touch
 * target while keeping the mockup's 46×28 visual. Two-way bind `checked`.
 *
 * @example <nb-switch [(checked)]="varsler" ariaLabel="Push-varsler" />
 */
@Component({
  selector: 'nb-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<button
    type="button"
    role="switch"
    class="switch"
    [class.on]="checked()"
    [attr.aria-checked]="checked()"
    [attr.aria-label]="ariaLabel() || null"
    [disabled]="disabled()"
    (click)="toggle()"
  >
    <i aria-hidden="true"></i>
  </button>`,
  styleUrl: './switch.css',
})
export class NbSwitch {
  readonly checked = model(false);
  readonly disabled = input(false);
  readonly ariaLabel = input<string>();

  protected toggle(): void {
    if (this.disabled()) return;
    this.checked.update((v) => !v);
  }
}
